/**
 * LineChart — DS Chart
 */

import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement,
  Title, Tooltip, Legend, Filler,
} from 'chart.js';
import styles from './LineChart.module.css';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, Filler);

interface LineChartProps {
  labels: string[];
  datasets: { label: string; data: number[]; color?: string }[];
  title?: string;
  height?: number;
  className?: string;
}

export function LineChart({ labels, datasets, title, height = 240, className = '' }: LineChartProps) {
  const colors = ['#9333ea', '#16a34a', '#2563eb', '#d97706'];
  return (
    <div className={`${styles.wrapper} ${className}`}>
      {title && <h4 className={styles.title}>{title}</h4>}
      <div style={{ height }}>
        <Line
          data={{
            labels,
            datasets: datasets.map((ds, i) => ({
              label: ds.label,
              data: ds.data,
              borderColor: ds.color ?? colors[i % colors.length],
              backgroundColor: `${ds.color ?? colors[i % colors.length]}18`,
              fill: true,
              tension: 0.4,
              pointRadius: 3,
              pointHoverRadius: 5,
            })),
          }}
          options={{
            responsive: true, maintainAspectRatio: false,
            plugins: { legend: { position: 'top', labels: { font: { family: 'Inter' }, boxWidth: 12 } }, title: { display: false } },
            scales: { x: { grid: { color: '#f3f4f6' } }, y: { grid: { color: '#f3f4f6' } } },
          }}
        />
      </div>
    </div>
  );
}
